const STORAGE_KEY = "bezierclick_portfolio";
const STORAGE_VERSION_KEY = "bezierclick_portfolio_version";
const CURRENT_STORAGE_VERSION = "veentto-case-study-2026-08-20";
const { DEFAULT_PROJECTS } = require("./portfolio-data");

export const getProjects = () => {
  try {
    const version = localStorage.getItem(STORAGE_VERSION_KEY);
    if (version !== CURRENT_STORAGE_VERSION) {
      saveProjects(DEFAULT_PROJECTS);
      return DEFAULT_PROJECTS;
    }

    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      const hasOnlyVeentto =
        Array.isArray(parsed) &&
        parsed.length === 1 &&
        parsed[0]?.url === "https://www.veenttovagos.com";

      if (!hasOnlyVeentto) {
        console.warn("Stored projects stale, resetting portfolio to Veentto Vagos");
        saveProjects(DEFAULT_PROJECTS);
        return DEFAULT_PROJECTS;
      }
      return parsed;
    }
  } catch (e) {
    console.error("Erro ao ler projetos", e);
  }
  saveProjects(DEFAULT_PROJECTS);
  return DEFAULT_PROJECTS;
};

export const saveProjects = (projects) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(projects));
    localStorage.setItem(STORAGE_VERSION_KEY, CURRENT_STORAGE_VERSION);
  } catch (e) {
    console.error("Erro ao guardar projetos", e);
  }
};

export const addProject = (project) => {
  const projects = getProjects();
  const newProject = {
    ...project,
    id: `${Date.now()}`,
  };
  projects.push(newProject);
  saveProjects(projects);
  return newProject;
};

export const updateProject = (id, data) => {
  const projects = getProjects();
  const index = projects.findIndex((p) => p.id === id);
  if (index !== -1) {
    projects[index] = { ...projects[index], ...data };
    saveProjects(projects);
    return projects[index];
  }
  return null;
};

export const deleteProject = (id) => {
  const projects = getProjects();
  const filtered = projects.filter((p) => p.id !== id);
  saveProjects(filtered);
};

export const getProjectById = (id) => {
  const projects = getProjects();
  return projects.find((p) => p.id === id);
};
